import { useMemo } from 'react';
import { GetCommunityConfigurationQuery } from '../../../../generated/gql';
import { useIntegratedQuery } from '../../../../hooks/useIntegratedQuery';
import GET_COMMUNITY_CONFIGURATION from '../../graphql/getCommunityConfiguration';

export const useCommunityConfiguration = () => {
  const { data, loading, error } =
    useIntegratedQuery<GetCommunityConfigurationQuery>(
      GET_COMMUNITY_CONFIGURATION,
      'community',
      {
        fetchPolicy: 'cache-first',
        context: {},
      },
    );
  return useMemo(
    () => ({
      configuration: data?.getConfiguration || undefined,
      loading,
      error,
    }),
    [data, loading, error],
  );
};
